import ToastMessage from '../components/ToastMessage';
export const toastConfig = {
  success: (props) => <ToastMessage {...props} />,
  error: (props) => <ToastMessage {...props} />,
  info: (props) => <ToastMessage {...props} />,
};
